import HttpClient from '@123/druid/dist/Components/Http/HttpClient';
import {injectable} from '@123/druid/dist/Framework/Decorators/Inject';
import type {AddProductRequest} from '@Component/ShoppingCart/Type/ShoppingCartRequest';
import Http from '@123/druid/dist/Utility/Http';
import {type AddProductResponse, addProductResponseSchema} from '@Component/ShoppingCart/Type/ShoppingCartResponse';

@injectable()
export default class ShoppingCartService {
    private readonly MODULE = 'shoppingcart';
    private readonly ADD_PRODUCT_ACTION = 'addProduct';

    constructor(private readonly httpClient: HttpClient = new HttpClient()) {}

    public addProduct(product: AddProductRequest): Promise<AddProductResponse> {
        const request = {
            module: this.MODULE,
            action: this.ADD_PRODUCT_ACTION,
            signature: window.signature,
            ...product,
        };

        return new Promise((resolve, reject) => {
            this.httpClient
                .post('', Http.toFormData(request), {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    'X-Requested-With': 'XMLHttpRequest',
                })
                .then(async (response: Response) => {
                    const result = addProductResponseSchema.safeParse(await response.json());
                    if (result.success === false) {
                        reject(new Error(result.error.message));
                        return;
                    }

                    /** Check if an error message is returned by the backend */
                    if ('error' in result.data) {
                        reject(new Error(result.error));
                        return;
                    }
                    resolve(result.data);
                })
                .catch(() => {
                    reject(new Error('Product can not be added'));
                });
        });
    }
}
